var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('h1',[_vm._v("MONITORING DASH")])]),_c('div',{staticClass:"row"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }